import { Button, Card, Typography } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { useGetUserSettings } from '@/core/hooks-and-services/userSettingsService'
import { EdsStyledIcon } from '@/styles/layout'
import Icon from '@/styles/icon'
import { account_circle as accountCircle } from '@equinor/eds-icons'
import { getAccountInfo, signOut } from '@/api/AuthConfig'
import PlantForm from '@/components/plantForm/PlantForm'

function User() {
    const { data } = useGetUserSettings()
    const account = getAccountInfo()
    const displayName = account?.name ?? data?.userId
    const claims = account?.idTokenClaims as Record<string, unknown> | undefined
    const role = (claims?.jobTitle as string | undefined) ?? (claims?.employeeType as string | undefined)

    return (
        <UserContainer>
            <PageHeading variant="h1">Profile & settings</PageHeading>
            <Card>
                <StyledContent>
                    <UserRow>
                        <StyledIcon data={accountCircle} size={24} />
                        <NameColumn>
                            <Typography variant="body_short">{displayName}</Typography>
                            {role && (
                                <Typography variant="caption" group="paragraph">
                                    {role}
                                </Typography>
                            )}
                        </NameColumn>
                    </UserRow>
                    <PlantForm />
                    <ButtonContainer>
                        <Button variant="ghost" color="primary" onClick={() => signOut()}>
                            <Icon name="logOut" />
                            Log out
                        </Button>
                    </ButtonContainer>
                </StyledContent>
            </Card>
        </UserContainer>
    )
}

const UserContainer = styled.div`
    background-color: rgb(245, 245, 245);
    padding: 16px;
`

const PageHeading = styled(Typography)`
    margin: 8px 0 16px;
`

const UserRow = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 4px;
    color: #6f6f6f;
    margin-bottom: 0;
`

const StyledContent = styled(Card.Content)`
    padding-top: 16px;
`

const NameColumn = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`

const StyledIcon = styled(EdsStyledIcon)`
    color: #007079;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
`

export default User
